<template>
  <div id="app">
    <NavbarComponent />
    <router-view></router-view>
  </div>
</template>

<script setup>
import NavbarComponent from '@/components/NavbarComponent.vue';
</script>

<style>
@import 'bootstrap';
@import 'datatables.net-bs5';
table.table {
  width: 100%;
}
table.table.dataTable > tbody > tr {
  font-size: small; /* Adjust to the desired font size */
}
.td-truncate {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}
.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
